// extracted by mini-css-extract-plugin
export default {"label":"Filter_label__ovCOv","input":"Filter_input__KyTwZ"};